import api from "@/lib/api";
import { cartItemsPayload } from "@/lib/customForm";

export function fastrrReady(config, country) {
  if (!config?.fastrr_checkout_active || !config?.fastrr_checkout) return false;
  if (country && String(country).toUpperCase() !== "IN") return false;
  return true;
}

export function loadFastrrSdk(scriptUrl) {
  return new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.HeadlessCheckout && typeof window.HeadlessCheckout.addToCart === "function") return resolve(true);
    const src = scriptUrl || "https://checkout-ui.shiprocket.com/js/headless.js";
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(Boolean(window.HeadlessCheckout)));
      existing.addEventListener("error", () => resolve(false));
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => resolve(Boolean(window.HeadlessCheckout && window.HeadlessCheckout.addToCart));
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

function isFastrrOrigin(origin) {
  const o = String(origin || "").toLowerCase();
  return o.includes("shiprocket") || o.includes("pickrr") || o.includes("fastrr");
}

export async function openFastrrCheckout({ slug, items, country, couponCode, customerEmail, customerName, config, deliverySlotId }) {
  const fr = config.fastrr_checkout || {};
  const { data } = await api.post(`/store/${slug}/fastrr/session`, {
    ...cartItemsPayload(items, country),
    coupon_code: couponCode || null,
    customer_email: customerEmail || null,
    customer_name: customerName || null,
  });
  const token = data.token;
  if (!token) {
    const err = new Error("Fastrr did not return a checkout token");
    err.code = "token";
    throw err;
  }
  const ok = await loadFastrrSdk(fr.script_url || data.script_url);
  if (!ok) {
    const err = new Error("Could not load Shiprocket Fastrr Checkout");
    err.code = "sdk";
    throw err;
  }
  const sessionId = data.session_id;
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      window.removeEventListener("message", onMsg);
      fn(value);
    };
    const onMsg = (ev) => {
      if (!isFastrrOrigin(ev.origin) && ev.source !== window) return;
      const payload = ev.data && typeof ev.data === "object" ? ev.data : {};
      const type = String(payload.type || payload.event || payload.name || "").toLowerCase();
      if (type.includes("order") && (type.includes("success") || type.includes("complete") || type.includes("placed"))) {
        finish(resolve, { status: "complete", order: payload, sessionId });
        return;
      }
      if (type.includes("close") || type.includes("dismiss") || type.includes("cancel")) {
        finish(resolve, { status: "close", sessionId });
      }
    };
    window.addEventListener("message", onMsg);
    try {
      window.HeadlessCheckout.addToCart(token);
    } catch (e) {
      finish(reject, e);
    }
  });
}
